module.exports = __webpack_public_path__ + "static/media/not-found-img.4bed5a43.png";